import styles from "./AppMonthCaption.module.scss";

import { type HTMLAttributes, useContext } from "react";

import { MonthSubtitleContext } from "../../context/MonthSubtitleContext";

export function AppMonthCaption(
  props: {
    calendarMonth: unknown;
    displayIndex: number;
  } & HTMLAttributes<HTMLDivElement>,
) {
  // if calendarMonth and displayIndex are passed to dom elements, react throws a warning.
  const { calendarMonth, displayIndex, className, children, ...divProps } =
    props;
  const subtitle = useContext(MonthSubtitleContext);

  return (
    <div className={`${className} ${styles.appMonthCaption}`} {...divProps}>
      <div className={styles.labelRow}>
        <div className={styles.label}>{children}</div>
      </div>
      {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
    </div>
  );
}
